import { render, staticRenderFns } from "./SecurityViewPermissions.vue?vue&type=template&id=529de572&scoped=true"
import script from "./SecurityViewPermissions.vue?vue&type=script&lang=js"
export * from "./SecurityViewPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529de572",
  null
  
)

export default component.exports